import styled, { css } from 'styled-components';
import NextImage from 'next/image';

import { heading3 } from 'Global/Typography';
import Link from 'Elements/Link';

export const Image = styled(NextImage)`
    object-fit: cover;
    transition: transform 0.2s ease-in-out;
`;

const containerStyle = css`
    display: block;
    text-decoration: none;
    color: inherit;
    width: 100%;

    &:hover {
        ${Image} {
            transform: scale(1.075);
        }
    }
`;

export const Container = styled.div`
    ${containerStyle}
`;

export const LinkContainer = styled(Link)`
    ${containerStyle}
`;

export const ImageContainer = styled.div`
    position: relative;
    padding-top: 100%;
`;

export const ImageWrapper = styled.div`
    position: absolute;
    overflow: hidden;
    border-radius: 50%;
    inset: 0;
`;

export const Inner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const HeadingStyles = ({ theme }) => css`
    font-size: 1.125rem;
    text-align: center;
    margin: 0.5rem 0 0;

    @media ${theme.breakpoints.large.media} {
        font-size: 1.25rem;
        margin-top: 0.75rem;
    }
`;

export const Heading = styled.h3`
    ${HeadingStyles}
    line-height: 1.4;
`;

export const Button = styled.button`
    ${heading3}
    ${HeadingStyles}
    border: none;
    background: transparent;

    &:hover {
        cursor: pointer;
    }
`;

export const FurtherDetails = styled.p`
    ${({ theme }) => css`
        font-size: 1rem;
        text-align: center;
        margin: 0;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.125rem;
        }
    `}
`;
